'use client';

import ArrowIcon from '@/components/ui/icons/arrow-icon';
import useCategoryStore from '@/store/category.store';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { usePathname } from '@/i18n/navigation';
import { useLocale } from 'next-intl';
import { useState } from 'react';
import NextLink from '@/components/next-link';

const Categories = () => {
  const menuTreeData = useCategoryStore((state) => state.menuTreeData);
  const [needsNavigation, setNeedsNavigation] = useState(false);
  const [swiper, setSwiper] = useState(null);
  const locale = useLocale();
  const pathname = usePathname();
  const checkNavigationNeed = (swiperInstance) => {
    if (!swiperInstance) return;
    const { slides, width: containerWidth } = swiperInstance;
    const totalSlidesWidth = Array.from(slides).reduce(
      (sum, slide) => sum + slide.offsetWidth,
      0
    );
    setNeedsNavigation(totalSlidesWidth > containerWidth);
  };

  return (
    !!menuTreeData?.length && (
      <section className='border-t-border border-t shadow-xs max-md:hidden'>
        <nav className='container mx-auto flex items-center justify-center gap-2 bg-white px-4 sm:gap-4 md:pt-1 md:pb-2.5 lg:py-2.5'>
          {needsNavigation && (
            <button
              className='hidden size-8 shrink-0 rotate-90 cursor-pointer items-center justify-center rounded-full border border-neutral-600 bg-white text-neutral-600 lg:flex rtl:rotate-270'
              onClick={() => swiper?.slidePrev()}
            >
              <ArrowIcon className='size-3' strokeWidth={2} />
            </button>
          )}

          <Swiper
            dir={locale === 'ar' ? 'rtl' : 'ltr'}
            slidesPerView='auto'
            spaceBetween={7}
            modules={[Navigation]}
            onSwiper={(swiper) => {
              setSwiper(swiper);
              checkNavigationNeed(swiper);
            }}
            onResize={checkNavigationNeed} // Re-check on resize
            loop={menuTreeData?.length > 10}
            breakpoints={{ 768: { spaceBetween: 20 } }}
          >
            {menuTreeData?.map((category, i) => (
              <SwiperSlide key={i} className='!w-auto'>
                <NextLink
                  className={`hover:text-primary flex justify-center rounded-lg px-3 py-2 text-sm font-semibold text-nowrap uppercase sm:px-5 ${category?.is_featured == '1' || pathname.endsWith(`-c-${category?.id}`) ? 'text-primary' : ''}`}
                  href={category?.currentURL}
                >
                  {category?.name}
                </NextLink>
              </SwiperSlide>
            ))}
          </Swiper>

          {needsNavigation && (
            <button
              className='hidden size-8 shrink-0 rotate-270 cursor-pointer items-center justify-center rounded-full border border-neutral-600 bg-white text-neutral-600 lg:flex rtl:rotate-90'
              onClick={() => swiper?.slideNext()}
            >
              <ArrowIcon className='size-3' strokeWidth={2} />
            </button>
          )}
        </nav>
      </section>
    )
  );
};

export default Categories;
